/**
 * Splits the video track name into three useable pieces of data
 */

export interface VideoTrackName {
  presenter: string
  source: string
  quality?: number
}

function splitVideoTrackName (trackName: string): VideoTrackName {

  /** The first three pieces are useful, everything after that is a unique id */
  const [presenter, source, qualityTemp] = trackName.split('-')
  const quality = Number.parseInt(qualityTemp)
  return {
    presenter,
    source,
    quality: Number.isNaN(quality) ? undefined : quality
  }

}

export default splitVideoTrackName
